module.exports = __webpack_public_path__ + "img/heidi-strauss.4ef6f737.jpg";